import React from 'react'

const ScissorsIcon = props => (
  <svg viewBox="0 0 18 18" {...props}>
    <path d="M15.36,4.05L13.95,2.64,9,7.59,7.7,6.29A3,3,0,1,0,6.29,7.7L7.59,9l-1.3,1.3A3,3,0,1,0,7.7,11.71L9,10.41l4.95,4.95,1.41-1.41L10.41,9ZM5,6A1,1,0,1,1,6,5,1,1,0,0,1,5,6Zm0,8a1,1,0,1,1,1-1A1,1,0,0,1,5,14Z" />
  </svg>
)

export default ScissorsIcon
